import React from 'react';
import Icon from '../../components/Icon';
import { Check } from '../../components/ui';
import { useTranslation } from '../../i18n';

interface StageAIProps {
  /** The AI's titles; null while it writes. */
  items: string[] | null;
  picked: number[];
  onPick: (index: number) => void;
  onAdd: () => void;
  onDismiss: () => void;
  busy: boolean;
}

/**
 * "AI önerisi · n görev" under a stage (T-189; the app's _AiPanel on m-asama): the suggested
 * tasks, all ticked; the ticked ones are added in their order, the rest go away.
 */
const StageAI: React.FC<StageAIProps> = ({ items, picked, onPick, onAdd, onDismiss, busy }) => {
  const { t } = useTranslation();
  return (
    <div className="gb-ai" role="region" aria-label={t('hedefler.aiSuggest')} aria-busy={items === null}>
      {items === null ? (
        <p className="gb-ai__note" role="status">
          <Icon name="sparkles" aria-hidden="true" /> {t('hedefler.aiLoading')}
        </p>
      ) : (
        <>
          <div className="gb-ai__head">
            <Icon name="sparkles" aria-hidden="true" />
            <strong>{t('hedefler.aiTitle', { count: items.length })}</strong>
          </div>
          <p className="gb-ai__note">{t('hedefler.aiNote')}</p>
          <ul className="gb-ai__list">
            {items.map((title, i) => (
              <li key={`${i}-${title}`}>
                <Check checked={picked.includes(i)} onChange={() => onPick(i)} label={t('hedefler.aiPick', { title })} small />
                <bdi>{title}</bdi>
              </li>
            ))}
          </ul>
          <div className="gb-ai__actions">
            <button type="button" className="ui-btn ui-btn--small" onClick={onDismiss} disabled={busy}>
              {t('hedefler.aiDismiss')}
            </button>
            <button type="button" className="ui-btn ui-btn--small ui-btn--primary" onClick={onAdd} disabled={busy || picked.length === 0}>
              {t('hedefler.aiAdd', { count: picked.length })}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default StageAI;
